const namespaced = true

import api from '../../../api/sap/items_sap';
import { downloadFile } from '../../../src/helpers/util.js'


const state = {
    data: null,
    items_avaible: [],
    items_avaible_flag: false,
    search: '',
    items: [],
    itemsByPrchseItem: [],
    typePrchseItem: null,
    itemsByDate: [],
    dates: null,

}

const mutations = {
    MUTATION_SET_DATA(state, articles) {
        state.data = articles
    },
    MUTATION_RESET_ITEMS_AVAIBLE(state) {
        state.items_avaible = []

    },
    MUTATION_RESET_ITEMS_AVAIBLE_FLAG(state, value) {
        state.items_avaible_flag = value;
    },
    MUTATION_SEARCH(state, value) {
        state.search = value;
    },
    MUTATION_ITEMS(state, data) {
        state.items = data;
    },
    MUTATION_SET_ITEMS_PRCHSE_ITEM(state, data) {
        state.itemsByPrchseItem = data;
    },
    MUTATION_SET_DATA_DATE(state, articles) {
        state.itemsByDate = articles
    },
    MUTATION_RESET_ITEMS_DATE(state) {
        state.itemsByDate = []

    },

}
const actions = {
    getArticles(context, all = false) {
        return new Promise((resolve) => {
            api.load_items(all).then(function (res) {
                context.commit('MUTATION_SET_ITEMS_AVAIBLE', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })
    },
    getArticlesByPrchseItem(context, all = false) {
        return new Promise((resolve) => {
            context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', true);
            api.load_items_by_PrchseItem(all).then(function (res) {
                context.commit('MUTATION_SET_ITEMS_PRCHSE_ITEM', res.data);
                context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', false);
                resolve(res.data);
            }).catch((e) => {
                context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', false);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })
    },
    getArticlesFamily(context, data) {
        return new Promise((resolve) => {
            context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', true);
            api.load_items_group(data.groupcodem, data.whsCode, data.page, 300).then(function (res) {
                context.commit('MUTATION_SET_DATA', res.data);
                context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', false);
                resolve(res.data);
            }).catch((e) => {
                context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', false);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('MUTATION_RESET_ITEMS_AVAIBLE');
            })
        })
    },
    resetArticles(context) {
        context.commit('MUTATION_RESET_ITEMS_AVAIBLE');
    },
    getArticlesSearch(context, data) {
        context.commit('MUTATION_SET_ITEMS_AVAIBLE', data)
    },
    setSearch(context, value) {
        context.commit('MUTATION_SEARCH', value)
    },
    getTotalItems(context, data) {
        return new Promise((resolve) => {
            context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', true);
            api.items(data).then(function (res) {
                context.commit('MUTATION_ITEMS', res.data);
                context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', false);
                resolve(res.data);
            }).catch((e) => {
                context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', false);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });

            })
        })
    },
    clearTotalItems(context){
        context.commit('MUTATION_SET_DATA', []);
    },
    getArticlesByDate(context, data) {
        const silent = data.silent === true;

        return new Promise((resolve) => {
            if (!silent) {
                context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', true);
            }
            api.load_items_by_date(data).then(function (res) {
                context.commit('MUTATION_SET_DATA_DATE', res.data);
                if (!silent) {
                    context.commit('MUTATION_RESET_ITEMS_AVAIBLE_FLAG', false);
                }
                resolve(res.data);
            }).catch(() => {
                context.commit('MUTATION_RESET_ITEMS_DATE');
            });
        });
    },

    exportDocument(context, data) {
        return new Promise((resolve, reject) => {
            //context.commit("MUTATION_SET_LOADING_DOWNLOAD", true);
            api.load_document_by_date(data).then(function (res) {
                const today = new Date();
                const fileName = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}_articulos-creados_.xlsx`;
                downloadFile(res.data, fileName);
                // context.commit("MUTATION_SET_LOADING_DOWNLOAD", false);
                resolve(res.data);
            })
                .catch((e) => {
                    // context.commit("MUTATION_SET_LOADING_DOWNLOAD", false);
                    const errorMsg = e.messages;
                    let finalMessage = "Ocurrió un error al exportar";
                    if (
                        errorMsg === "undefined\nundefined" ||
                        !errorMsg ||
                        errorMsg.trim() === "" ||
                        typeof errorMsg !== "string"
                    ) {
                        finalMessage = "Sin suficientes registros";
                    } else {
                        finalMessage = errorMsg;
                    }
                    context.dispatch(
                        "notifications/add",
                        {
                            color: "error",
                            visibility: true,
                            timeout: 5000,
                            text: finalMessage,
                        },
                        { root: true }
                    );
                    reject();
                    console.log(e);
                });
        });
    },




}

const getters = {
    getArticlesItem(state) {
        return (state.data != null) ? state.data.items : []
    },
    getNextPage(state) {
        return (state.data != null) ? state.data.nextPage : null
    },
    getAntPage(state) {
        return (state.data != null) ? state.data.antPage : null
    },
    getCountItems(state) {
        return (state.data != null) ? state.data.total : null
    },

    getTotalItems(state) {
        if (state.data == null || state.search == '')
            return 0;
        const lowerSearch = state.search.toString().toLowerCase();
        const searchKeywords = lowerSearch.split(' ');
        let matchCount = 0;
        for (var i = 0; i < state.data.items.length; i++) {
            let existCount = true;
            for (var j = 0; j < searchKeywords.length; j++) {
                if (state.data.items[i].ItemCode.toString().toLowerCase().includes(searchKeywords[j].toString().toLowerCase()) ||
                    state.data.items[i].ItemName.toString().toLowerCase().includes(searchKeywords[j].toString().toLowerCase())) {
                    existCount = true;
                } else {
                    existCount = false;
                    break;
                }
            }
            if (existCount)
                matchCount++
        }
        return matchCount;
    },

    dateRangeByItem: () => (id) => {
        const today = new Date();
        const formatDate = (d) => d.toISOString().split('T')[0];

        const cloneAndSubtract = (days) => {
            const date = new Date(today);
            date.setDate(date.getDate() - days);
            return formatDate(date);
        };

        switch (id) {
            case 1:
                return { start_date: formatDate(today), end_date: formatDate(today) };
            case 2:
                return { start_date: cloneAndSubtract(3), end_date: formatDate(today) };
            case 3:
                return { start_date: cloneAndSubtract(7), end_date: formatDate(today) };
            case 4:
                return { start_date: cloneAndSubtract(30), end_date: formatDate(today) };
            default:
                return null;
        }
    },
    itemsFilter: (state) => state.items
}
export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}